const Empty = () => {
    return (<svg width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="8-通用信息" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="03-灰白款" transform="translate(-974.000000, -1075.000000)">
              <g id="空备份" transform="translate(974.000000, 1075.000000)">
                  <rect id="矩形备份-3" fill-opacity="0" fill="#EFE9DE" x="0" y="0" width="200" height="200"></rect>
                  <g id="Page-1" transform="translate(25.000000, 40.000000)">
                      <polygon id="Fill-1" fill="#C8C8C8" points="78.3344118 -9.77625479e-05 78.3344118 41.2224582 131.360882 20.3169149"></polygon>
                      <polygon id="Fill-2" fill="#D3D3D3" points="78.3344118 -9.77625479e-05 16.177549 20.3169149 14.9657843 22.2780316 66.3206863 45.9619865 78.3344118 41.2224582"></polygon>
                      <polygon id="Fill-3" fill="#F4F4F4" points="66.3202941 119.581193 134.017353 90.7158234 135.021498 52.7575568 77.712451 76.4131627 66.3202941 45.615537"></polygon>
                      <polygon id="Fill-4" fill="#EAEAEA" points="65.5826471 46.2569361 66.319902 47.335257 77.7120588 76.4137492 149.392451 48.1036706 131.361078 20.3166216"></polygon>
                      <polygon id="Fill-5" fill="#DDDDDD" points="56.075545 75.8531144 15.195 51.4025775 15.195 89.734483 66.3204902 118.927357 66.3204902 45.6941668"></polygon>
                      <polygon id="Fill-6" fill="#EAEAEA" points="0 43.4123392 56.0911765 76.4296845 66.3205882 45.9619865 14.9656863 22.2780316"></polygon>
                  </g>
              </g>
          </g>
      </g>
    </svg>);
};
export default Empty;
